import * as actions from './slice'

const getTenantContent = {
  eventName: 'promotedContentSearch',
  onSuccess: {
    action: actions.getTenantContent,
    redux: true
  }
}

const fetchTenantContent = {
  eventName: 'promotedContentSearch',
  onSuccess: {
    action: actions.fetchTenantContent,
    redux: true
  }
}

export {
  getTenantContent,
  fetchTenantContent
}
